module.exports = __webpack_public_path__ + "fonts/opensans-bold.f2612f75.woff";